module.exports = __webpack_public_path__ + "img/marker.45572a39.svg";